module.exports = __webpack_public_path__ + "img/eggs_salmon_avo.dd715bd5.jpg";